import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'hooks/redux'
import { getIsEditing } from 'selectors/navigator'
import { getFunctionOutput } from 'selectors/feature/outputs'
import { getFeatureModuleType } from 'selectors/feature/featureMetadata'

import OutputNodeEditor from './OutputNodeEditor'
import OutputNodeReadonly from './OutputNodeReadonly'
import withStyle from './OutputNodePane.style.js'
import { ViewNotesButton } from '../FeatureNotes/FeatureNotes'

const OutputNodePane = ({ className, ...navigatorProps }) => {
  const isEditing = useSelector(getIsEditing)
  const { id } = navigatorProps

  const output = useSelector(getFunctionOutput, { id })
  const featureModuleType = useSelector(getFeatureModuleType)
  const { type, description } = output || {}
  const props = {
    output,
    featureModuleType,
    ...navigatorProps,
  }

  return (
    <>
      <ViewNotesButton id={id} fromType={type} description={description} />
      {isEditing ? (
        <OutputNodeEditor {...props} />
      ) : (
        <OutputNodeReadonly {...props} />
      )}
    </>
  )
}

OutputNodePane.defaultProps = {}

OutputNodePane.propTypes = {
  /** Classname */
  className: PropTypes.string,
}

export default withStyle(OutputNodePane)
